import fadeTabs from '../../components/tabs.js';
import { fadeOut, fadeIn } from '../../utility';

const tabsContainer = document.querySelector('[data-fade-tabs]');

init();

function init() {
  return new fadeTabs(tabsContainer, {
    childSelector: '[data-fade-tabs-id]',
    activeClass: 'content-tabs__tab--active',
    onSelect: (activeTab, inactiveTabs) => {
      inactiveTabs.forEach(tab => {
        fadeOut(tabsContainer.querySelector(`[data-fade-tabs-content="${tab.getAttribute('data-fade-tabs-id')}"]`), {
          done() {
            fadeIn(tabsContainer.querySelector(`[data-fade-tabs-content="${activeTab.getAttribute('data-fade-tabs-id')}"]`));
          },
        });
      });
    },
  });
}
